// Global variables and functions
window.enableStickyAddToCart = false;
const selectors = {
  elToObserve: ".sticky-form-wrapper",
  stickyEl: ".sticky-form",
  stickyClass: "stick",
  minScrollThreshold: 100
};

// Global function to update sticky state
function updateStickyState(shouldShow) {
  const elementToStick = document.querySelector(selectors.stickyEl);
  if (elementToStick) {
    if (shouldShow && window.enableStickyAddToCart) {
      elementToStick.classList.add(selectors.stickyClass);
      document.body.classList.add("sticky-form-active");
    } else {
      elementToStick.classList.remove(selectors.stickyClass);
      document.body.classList.remove("sticky-form-active");
    }
  }
}

// Global toggle function
window.toggleStickyCart = function(enable) {
  window.enableStickyAddToCart = enable;
  const elementToObserve = document.querySelector(selectors.elToObserve);
  if (elementToObserve && window.innerWidth <= 768) {
    const elementRect = elementToObserve.getBoundingClientRect();
    updateStickyState(elementRect.bottom < 0);
  }
};

// Main functionality
(function() {
  if (window.innerWidth <= 768) {
    const elementToObserve = document.querySelector(selectors.elToObserve);
    const elementToStick = document.querySelector(selectors.stickyEl);
    
    if (!elementToObserve || !elementToStick) return;

    let lastScrollY = window.scrollY;
    let hasPassedThreshold = false;

    // Throttle scroll events
    let ticking = false;
    const throttleScroll = (callback) => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          callback();
          ticking = false;
        });
        ticking = true;
      }
    };

    // Handle scroll events
    window.addEventListener('scroll', () => {
      throttleScroll(() => {
        const currentScrollY = window.scrollY;
        hasPassedThreshold = currentScrollY > selectors.minScrollThreshold;
        lastScrollY = currentScrollY;

        if (elementToObserve) {
          const elementRect = elementToObserve.getBoundingClientRect();
          updateStickyState(elementRect.bottom < 0 && hasPassedThreshold);
        }
      });
    });

    // Create intersection observer
    const observer = new IntersectionObserver(
      function(entries) {
        const [entry] = entries;
        updateStickyState(!entry.isIntersecting && hasPassedThreshold);
      },
      {
        root: null,
        rootMargin: "-10px 0px 0px 0px",
        threshold: 0
      }
    );

    // Start observing
    observer.observe(elementToObserve);

    // Cleanup
    window.addEventListener("unload", () => {
      observer.disconnect();
    });
  }
})();
